// @flow
import { connect } from "react-redux";

import { getActiveModels } from "../_modularui/ModularUISelectors";

import type { ReduxState } from "../types";
import type Href from "../../models/href/Href";
import type { ComponentType } from "react";

type StateProps = {
  items: Array<{ key: string, href: Href, label: string, type: string }>,
};
type Props = { ...StateProps, ... };

const mapStateToProps = (state: ReduxState): StateProps => ({
  items: getActiveModels(state),
});

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useActiveModels' instead
 */
export const connectBreadcrumb: ComponentType<any> = connect<
  Props,
  {},
  _,
  _,
  _,
  _,
>(mapStateToProps);
